import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-blue-dart-create',
  templateUrl: './blue-dart-create.component.html',
  styleUrls: ['./blue-dart-create.component.scss'],
})
export class BlueDartCreateComponent implements OnInit {

  carrierName: string;
  carrierNameError: string;
  licenseKey: string;
  licenseKeyError: string;
  customerCode: string;
  customerCodeError: string;
  userName: string;
  userNameError: string;
  version: string;
  versionError: string;
  password: string;
  passwordError: string;
  apiType: string;
  apiTypeError: string;
  area: string;
  areaError: string;

  constructor(private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  licenseKeyBlur() {
    this.licenseKeyError = "";
    if (!this.licenseKey) {
      this.licenseKeyError = 'Please enter license key';
    }
  }

  customerCodeBlur() {
    this.customerCodeError = "";
    if (!this.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
  }

  userNameBlur() {
    this.userNameError = "";
    if (!this.userName) {
      this.userNameError = 'Please enter user name';
    }
  }

  versionBlur() {
    this.versionError = "";
    if (!this.version) {
      this.versionError = 'Please enter version';
    }
  }

  passwordBlur() {
    this.passwordError = "";
    if (!this.password) {
      this.passwordError = 'Please enter password';
    }
  }

  apiTypeBlur() {
    this.apiTypeError = "";
    if (!this.apiType) {
      this.apiTypeError = 'Please enter api type';
    }
  }

  areaBlur() {
    this.areaError = "";
    if (!this.area) {
      this.areaError = 'Please enter area';
    }
  }

  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.licenseKeyError = "";
    this.customerCodeError = "";
    this.userNameError = "";
    this.versionError = "";
    this.passwordError = "";
    this.apiTypeError = "";
    this.areaError = "";

    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.licenseKey) {
      this.licenseKeyError = 'Please enter license key';
    }
    if (!this.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
    if (!this.userName) {
      this.userNameError = 'Please enter user name';
    }
    if (!this.version) {
      this.versionError = 'Please enter version';
    }
    if (!this.password) {
      this.passwordError = 'Please enter password';
    }
    if (!this.apiType) {
      this.apiTypeError = 'Please enter api type';
    }
    if (!this.area) {
      this.areaError = 'Please enter area';
    }
    if (this.carrierNameError != "" || this.licenseKeyError != "" || this.customerCodeError != "" || this.userNameError != "" || this.versionError != "" || this.passwordError != "" || this.apiTypeError != "" || this.areaError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body


    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyAndSaveCarrierCredentials', {

      "accountOwnerId": this.user.accountOwnerId,
      "carrierCode": "BD",
      "connectionName": this.carrierName,
      "organizationId": 1,
      "apiType": this.apiType,
      "area": this.area,
      "version": this.version,
      "customerCode": this.customerCode,
      "licenceKey": this.licenseKey,
      "password": this.password,
      "username": this.userName

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Blue Dart', 'Create Successfully');
          this.router.navigate(['/admin/customerCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}

